export abstract class Query<TResult> {
  protected readonly __resultType?: TResult;
}
